export default __webpack_public_path__ + "images/light-gray-circle.1e23cc42d0db41df4c62a2f1fc49bb21.svg";